"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseHtmlWithInfoIconWidget = void 0;
var React = require("react");
/**
 * Widget to render some html like label or header with Info icon in the right side (props -> header)
 * And collapsed html content (props -> content)
 */
var CollapseHtmlWithInfoIconWidget = /** @class */ (function (_super) {
    __extends(CollapseHtmlWithInfoIconWidget, _super);
    function CollapseHtmlWithInfoIconWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.sendState = function () {
            _this.props.parentCallback(!_this.state.showInfo);
        };
        _this.showInfoHandler = _this.showInfoHandler.bind(_this);
        _this.sendState = _this.sendState.bind(_this);
        _this.state = {
            showInfo: false
        };
        return _this;
    }
    CollapseHtmlWithInfoIconWidget.prototype.render = function () {
        return (React.createElement("div", { className: "widget collapse-label-widget" },
            React.createElement("div", { className: "media pt-3", onClick: this.showInfoHandler },
                React.createElement("div", { className: "label-body" }, this.props.header),
                React.createElement("span", { className: "col-2" },
                    React.createElement("div", { tabIndex: 0, "aria-label": this.props.title, onKeyPress: this.showInfoHandler, className: this.state.showInfo ? "info-button selected" : "info-button" }))),
            React.createElement("div", { className: this.state.showInfo ? "d-block" : "d-none" }, this.props.content)));
    };
    CollapseHtmlWithInfoIconWidget.prototype.showInfoHandler = function () {
        this.sendState();
        this.setState({
            showInfo: !this.state.showInfo
        });
    };
    return CollapseHtmlWithInfoIconWidget;
}(React.Component));
exports.CollapseHtmlWithInfoIconWidget = CollapseHtmlWithInfoIconWidget;
//# sourceMappingURL=CollapseHtmlWithInfoIconWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/CollapseHtmlWithInfoIconWidget.js
// module id = 353
// module chunks = 0